import React, { useState } from "react";
import styled from "@emotion/styled";

export const ProductDescription = ({ description }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <DescriptionContainer>
            <DescriptionContent
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: description }}
                expanded={expanded}
            />
            {description && description.length > 200 && (
                <ReadMoreButtonContainer>
                    <ReadMoreButton onClick={() => setExpanded((e) => !e)}>
                        {expanded ? "Read less" : "Read more"}
                    </ReadMoreButton>
                </ReadMoreButtonContainer>
            )}
        </DescriptionContainer>
    );
};

const DescriptionContainer = styled.div`
    .ql-editor {
        padding: 0;
    }
`;

const DescriptionContent = styled.div`
    max-height: ${({ expanded }) => (expanded ? 'none' : '8em')};
    overflow: hidden;
    position: relative;
    transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1);
    ${({ expanded }) => !expanded && `
        mask-image: linear-gradient(to bottom, black 60%, transparent 100%);
    `}
`;

const ReadMoreButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
`;

const ReadMoreButton = styled.button`
    background: none;
    border: none;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
    text-decoration: underline;
    font-size: 1rem;
`;